import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/v2/constants/QueryKeys';
import useCurrentUser from '@/v2/domains/Auth/hooks/useCurrentUser.hook';
import authConstants from '@/v2/domains/Auth/constants/constants';

import getStudentClasses from '@/api/studentDashboard/getStudentClasses.endpoint';

interface StudentRawClass {
  id: number;
  name: string;
  internalUse: boolean;
  subscriptionId: number;
  isAutoPilot: boolean;
  classStudents: { movedAt: string | null; createdAt: string }[];
  subscription: {
    teacherId: number;
    teacher: { firstName: string; lastName: string };
  };
}

const anHour = 60 * 60 * 1000;

export default function useGetStudentClassesQuery() {
  const { userId, userType } = useCurrentUser();

  return useQuery<StudentRawClass[]>({
    queryKey: [QUERY_KEYS.STUDENT_CLASSES, userId],
    queryFn: () => getStudentClasses(),
    enabled: userType == authConstants.userType.student,
    staleTime: anHour,
    refetchOnWindowFocus: false,
    meta: {
      notification: {
        error: 'There was a problem loading the student class',
      },
    },
  });
}
